<template>
  <el-form label-width="80px" :model="formmodel">
    <el-form-item label="视频号ID:">
      <el-input v-model="formmodel.name" @input="changeFunc"></el-input>
     </el-form-item>
     <el-form-item label="">
      <p>视频号id（参考格式为：sphcqO59YEPCvoe；查看路径为：微信客户端->我tab->视频号->右上角.-＞视频号名字-视频号ID）</p>
    </el-form-item>
  </el-form>
</template>

<script>
  export default{
    data(){
      return {
        /*form模型*/
        formmodel: {}
      }
    },
    methods:{
      /*选中的值*/
      changeFunc(e){
        //从e中把name和ur赋值到下面的对象
        let boj={
          url_type:'channel',
          type:'视频号ID',
          name:e,
          url:e
        }
        this.$emit('changeData',boj);
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Channel.vue